import {Site} from '../models/site';
import {SubinventoryType} from '../models/subinventory';
import {Division} from "@shared/models/division";

export interface SiteInfo {
    isScsSite: boolean;
    isPlant: boolean;
    isTpm: boolean;
    isRlc: boolean;
    isSortOnlyRlc: boolean;
    isStorage: boolean;
    isUAC: boolean;
    isAssetRecovery: boolean;
    isPeco: boolean;
    hasPlant: boolean;
    hasTpm: boolean;
    hasStorage: boolean;
    hasUac: boolean;
    hasAssetRecovery: boolean;
    hasVop: boolean;
    hasPeco: boolean;
    hasIgps: boolean;
    hasRm2: boolean;
}

export function getSiteInfo(site: Site): SiteInfo {
    const hasPlant = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.ChepPlantPallets);
    const hasTpm = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.TpmProduction);
    const hasStorage = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.ChepPalletStorage);
    const hasUac = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.UsedAssetCenter);
    const hasAssetRecovery = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.AssetRecovery);
    const hasVop = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.VendorOnPremise);
    const hasPeco = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.PecoPallets);
    const hasIgps = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.IgpsPallets);
    const hasRm2 = site.subinventories.some(s => s.isActive && s.subinventoryType === SubinventoryType.Rm2Pallets);

    return {
        isScsSite: hasPlant || hasTpm || hasStorage || hasUac || hasPeco || hasIgps || hasRm2,
        hasPlant,
        hasTpm,
        hasStorage,
        hasUac,
        hasVop,
        hasAssetRecovery,
        hasPeco,
        hasIgps,
        hasRm2,
        isPlant: hasPlant && !hasTpm,
        isTpm: hasTpm && !hasPlant,
        isRlc: hasTpm && hasPlant,
        isSortOnlyRlc: hasTpm && !hasPlant && site.division === Division.Rlc,
        isStorage: hasStorage && !hasTpm && !hasPlant,
        isUAC: hasUac && !hasTpm && !hasPlant,
        isAssetRecovery: hasAssetRecovery && !hasPlant && !hasTpm,
        isPeco: hasPeco && !hasPlant && !hasTpm,
    };
}

